import { ITableHeaders } from '@Models/common.model'

// models section
interface ITableInvoice {
    data: any
    headers: ITableHeaders[]
}

function TableInvoice(props: ITableInvoice) {
    // main section
    const { data, headers } = props

    // functions section
    const formattedDataByFormatType = (childData: any, formatType: string) => {
        switch (formatType) {
            default:
                return childData
        }
    }

    // elements section
    /**
     * create header row of table
     */
    const tableHeaderElements = headers?.map(
        (header: ITableHeaders, index: number) => {
            return (
                <th key={`${header?.key}_header_${+index}`}>{header?.name}</th>
            )
        }
    )

    /**
     * create data row of table
     */
    const tableContentElements = data?.map(
        (dataItem: any, dataIndex: number) => {
            return (
                <tr key={`table_data_${+dataIndex}`}>
                    {headers?.map((thItem: ITableHeaders) => {
                        const { key, name, formatType } = thItem
                        return (
                            <td key={key}>
                                {formattedDataByFormatType(
                                    dataItem[key],
                                    formatType || ''
                                )}
                            </td>
                        )
                    })}
                </tr>
            )
        }
    )

    // main
    return (
        <table className="page-table mt-4">
            <tbody>
                {/* table header section */}
                <tr>{tableHeaderElements}</tr>

                {/* table content section */}
                {tableContentElements}
            </tbody>
        </table>
    )
}

export default TableInvoice
